// test1380
(1380 && 0);
